import { AcessosModel, ClienteLogAcessoModel } from '@/domain/models'
import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols'
import { GetAccessLog, GetAccessLogParams, GetAccessLogPeriodoParams } from '@/domain/usecases'

export class RemoteGetAccessLog implements GetAccessLog {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<AcessosModel | ClienteLogAcessoModel[]>
  ) { }

  async getAll (params?: GetAccessLogParams): Promise<AcessosModel> {
    const request: HttpRequest = {
      url: `${this.url}/api/portal/acessos`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }
        return body as AcessosModel
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }

  async getByPeriodo (params: GetAccessLogPeriodoParams): Promise<ClienteLogAcessoModel[]> {
    const request: HttpRequest = {
      url: `${this.url}/api/portal/acessos-periodo`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        return (body as ClienteLogAcessoModel[]) ?? []
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
